import { GroupBase } from 'chakra-react-select';
import { Flex, Text } from '@chakra-ui/react';
import { GROUP_HEADER_HEIGHT_PIXELS } from '../constants';

export const GroupHeading = <Option extends {}>({
  label,
}: GroupBase<Option>) => (
  <Flex height={`${GROUP_HEADER_HEIGHT_PIXELS}px`} px={1} align="center">
    <Text
      fontWeight={600}
      color="textSubdued"
      fontSize="xxs"
      textTransform="uppercase"
      mt={2}
    >
      {label}
    </Text>
  </Flex>
);
